// extracted by mini-css-extract-plugin
export default {"spinner":"layouy_spinner__tcky2"};